import React from 'react';
import { Facebook, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="w-full bg-zinc-900 border-t border-zinc-800 py-6 mt-auto">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Réseaux sociaux */}
        <div className="flex flex-col items-center gap-4 mb-4">
          <h3 className="text-white font-semibold text-lg">RESTEZ CONNECTÉS</h3>
          <div className="flex gap-6">
            {/* Facebook */}
            <a
              href="https://web.facebook.com/profile.php?id=100090712813142&locale=fr_FR"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-zinc-400 hover:text-[#E50914] transition-colors"
            >
              <Facebook size={24} />
              <span className="hidden sm:inline">Facebook</span>
            </a>
            
            {/* YouTube */}
            <a
              href="https://www.youtube.com/@RaoulMavuna"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-zinc-400 hover:text-[#E50914] transition-colors"
            >
              <Youtube size={24} />
              <span className="hidden sm:inline">YouTube</span>
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center text-zinc-500 text-sm border-t border-zinc-800 pt-4">
          <p>© 2014-2025 AGRP BOX | Créé depuis 2014 - Développé par Daniel Mawodjo | www.agrpbox.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
